<template>
	<div class="template textarea" v-show="dataVal.IsShow || dataVal.IsShow == null">
		<div class="panel_wrap">
			<div class="file-wrap-title">{{dataVal.Property.Title[0].Text}}<span v-show="dataVal.Property.Require==1" class="require">*</span>
			</div>
			<div class="panel_content" :class="{color: dataVal.Property.Title[0].Text.indexOf('财务报销提示' )>-1}">
				<el-input type="textarea" :rows="4" :autosize="{ minRows: 2, maxRows: 6}" :readOnly="dataVal.Disable||dataVal.Property.Title[0].Text=='晋升说明'||dataVal.Property.Title[0].Text=='端口费用承担部门'||dataVal.Property.Title[0].Text=='捐款申请'" :placeholder="dataVal.Property.Placeholder[0].Text" v-model="dataVal.Value">
				</el-input>

				<!-- <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="dataVal.Value">
				</el-input> -->
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['dataVal'],
		data() {
			return {

			}
		},
		created(){
			this.init();
			
		},
		methods: {
			init(){
				if(this.dataVal.Property.Title[0].Text.indexOf('财务报销提示')>-1){
					this.dataVal.IsShow = true;
					this.dataVal.Value = this.dataVal.Property.Placeholder[0].Text;
					this.dataVal.Disable = true;
				}
			}

		},
		mounted() {
			
		}
	}
</script>

<style>
	@import '../assets/css/common.css';

	.panel_wrap {
		display: block;
	}
	.color .el-textarea__inner{
		color: #FF4346 !important;
	}
</style>
